import React from "react";
import {Breadcrumb, Button, Input, Collapse} from "antd";
import {DatabaseOutlined, SettingOutlined} from "@ant-design/icons";
import "./cod.scss";
import Kazakhstan from "@maps/Kazakhstan.png";
import {Link} from "react-router-dom";
import {administration} from "@store/administrationData";


const COD = () => {
    const {Panel} = Collapse;

    const onChange = (key) => {
        console.log(key);
    };

    return (
        <>
            <div className="breadcrumb">
                <Breadcrumb
                    style={{
                        margin: '16px 0',
                    }}
                >
                    <Breadcrumb.Item>
                        <SettingOutlined/>
                        <span>Сервисы</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <DatabaseOutlined/>
                        <span>ЦОД</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div className="cod-page">
                <h1 className="title">Центры обработки данных Казахстана</h1>
                <div className="search-wrapper">
                    <h4 className="search-title">Выберите вид поиска</h4>
                    <div className="search-block">
                        <div className="search-input">
                            <Input placeholder="поиск по названию ЦОДа"/>
                        </div>
                        <div className="search-input">
                            <Input placeholder="поиск по адресу"/>
                        </div>
                        <Button type="primary">Найти</Button>
                    </div>
                </div>
                <div className="kazakhstan-map">
                    <img src={Kazakhstan} alt=""/>
                </div>
                <h1 className="title">Административные территории</h1>
                <div className="collapse-container">
                    {administration.map((a, index) => (
                        <Collapse className="collapse" key={index} onChange={onChange}>
                            <Panel header={a.header} key="1">
                                {a.codName.map((cod, index) => (
                                    <div className="item-list" key={index}>
                                        <span className="item"></span>
                                        <span><Link to={`${cod.id}`}>{cod.name}</Link></span>
                                    </div>
                                ))}
                            </Panel>
                        </Collapse>
                    ))}
                </div>
            </div>
        </>
    )
}

export default COD;
